import React from "react";
import "./WithContainer.css";
import classNames from "classnames";

const WithContainer = (WrappedComponent) => (props) => {
  const { type, isAuto } = props;

  let classes = classNames({
    mainAppTimer: type === 1,
    mainAppText: type === 1,
    withMargin: !isAuto,
    flexGrow: type === 1,
    green: true,
    modalTimer: type === 2 || type === 3,
    modalTimerText: type === 2 || type === 3,
  });

  return <WrappedComponent className={classes} {...props}></WrappedComponent>;
};

export default WithContainer;
